<template>
  <div class="d-flex align-items-center">
    <Tooltip :bottom="tooltipBottom" :left="tooltipLeft">
      <template #element>
        <Icon
          class="mx-1"
          :width="iconSize"
          :height="iconSize"
          :exp-active="true"
          icon="fully-editable"
        />
      </template>
      <template #title>
        {{ $t('home.merch.sector6.tooltipTitle') }}
      </template>
      {{ $t('home.merch.sector6.tooltipDescription') }}
    </Tooltip>
    <Tooltip :bottom="tooltipBottom" :left="tooltipLeft">
      <template #element>
        <Icon
          class="mx-1"
          :width="iconSize"
          :height="iconSize"
          :exp-active="true"
          icon="scalable-size"
        />
      </template>
      <template #title>
        {{ $t('home.merch.sector6.tooltip2Title') }}
      </template>
      {{ $t('home.merch.sector6.tooltip2Description') }}
    </Tooltip>
    <Tooltip :bottom="tooltipBottom" :left="tooltipLeft">
      <template #element>
        <Icon
          class="mx-1"
          :width="iconSize"
          :height="iconSize"
          :exp-active="true"
          icon="transparent-png"
        />
      </template>
      <template #title>
        {{ $t('home.merch.sector6.tooltip3Title') }}
      </template>
      {{ $t('home.merch.sector6.tooltip3Description') }}
    </Tooltip>
    <div v-if="showSeeMore" class="mx-2">
      <Button
        shape="outline"
        size="small"
        font-size="13"
        color="white"
        text="gray"
        hover="exp"
        :to="$trailingSlash(localePath(link))"
      >
        {{ seeMoreText }}
      </Button>
    </div>
  </div>
</template>

<script>
import Icon from 'UI/Icon';
import Button from 'UI/Button';
import Tooltip from '@/components/Common/Tooltip';
export default {
  components: {
    Button,
    Icon,
    Tooltip
  },
  props: {
    showSeeMore: {
      type: Boolean,
      required: false,
      default: true
    },
    link: {
      type: String,
      required: false,
      default: 'svg-png'
    },
    seeMoreText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      iconSize: 35,
      tooltipBottom: 145,
      tooltipLeft: 21
    };
  }
};
</script>
